<button
  class="hud-button"
  [class.is-disabled]="isDisabled()"
  [disabled]="isDisabled()"
  style="width: 100%; height: 100%; display: grid; grid-template-areas: 'stack'"
>
  @let sprite =
    kind() === 'PRIMARY'
      ? _stylesService.HUD_BUTTON_PRIMARY()
      : kind() === 'SECONDARY'
        ? _stylesService.HUD_BUTTON_SECONDARY()
        : kind() === 'SUCCESS'
          ? _stylesService.HUD_BUTTON_SUCCESS()
          : _stylesService.HUD_BUTTON_DANGER();
  @let sprite2 = isDisabled() ? _stylesService.HUD_BUTTON_DISABLED() : sprite;
  <app-style-sheet-sprite
    [sprite]="_stylesService.HUD_BUTTON_DISABLED()?.container"
    [text]="_stylesService.HUD_BUTTON_DISABLED()?.text"
    style="grid-area: stack"
  >
    <div style="height: 100%; display: grid; place-items: center; text-align: center"></div>
  </app-style-sheet-sprite>
  <div
    style="grid-area: stack"
    [style]="{
      transition: 'opacity 0.25s ease',
      opacity: isDisabled() ? 0 : 1,
    }"
  >
    <app-style-sheet-sprite [sprite]="sprite?.container" [text]="sprite?.text">
      <div style="height: 100%; display: grid; place-items: center; text-align: center"></div>
    </app-style-sheet-sprite>
  </div>
  <div style="grid-area: stack; pointer-events: none; visibility: hidden">
    <!-- TODO: as a workaround for not being able to place the <ng-content> in multiple places, we use a 'transparent sprite' -->
    <app-style-sheet-sprite [sprite]="sprite2?.container" [text]="sprite2?.text">
      <div style="height: 100%; display: grid; place-items: center; text-align: center; visibility: visible">
        <ng-content></ng-content>
      </div>
    </app-style-sheet-sprite>
  </div>
</button>
